<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">
          {{ operationType === 'improve' ? (globalDataArray.siteTemplateLanguage.person_team_member || '团队成员信息') : (globalDataArray.siteTemplateLanguage.person_team_member || '团队成员证书信息') }}
        </div>
        <!-- <div class="selector-description mb-3">
          {{ operationType === 'improve' ? (globalDataArray.siteTemplateLanguage.please_select_member_for_improve || '请选择要为哪个成员完善认证信息：') : (globalDataArray.siteTemplateLanguage.please_select_member_for_certificate || '请选择要为哪个成员完善证书信息：') }}
        </div> -->
        <div>
          <a-table
            :columns="columns"
            :data-source="tableData"
            :pagination="false"
            :row-key="record => record.id"
            size="middle"
          >
            <template slot="memberName" slot-scope="text, record">
              <span class="member-name">{{ record.userName || record.personName || (globalDataArray.siteTemplateLanguage.unnamed || '未命名') }}</span>
            </template>
            <!-- <template slot="role" slot-scope="text, record">
              <a-tag :color="record.isCaptain === 1 ? 'green' : 'blue'">
                {{ record.isCaptain === 1 ? (globalDataArray.siteTemplateLanguage.team_captain || '队长') : (globalDataArray.siteTemplateLanguage.team_member || '队员') }}
              </a-tag>
            </template> -->
            <template slot="contact" slot-scope="text, record">
              <span>{{ record.userPhone || record.phoneNumber || '-' }}</span>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button
                type="primary"
                size="small"
                @click="handleSelect(record)"
              >
                {{ operationType === 'improve' ? (globalDataArray.siteTemplateLanguage.improve_information || '完善认证信息') : (globalDataArray.siteTemplateLanguage.improve_information2 || '完善证书信息') }}
              </a-button>
            </template>
          </a-table>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default {
  name: 'TeenagerInfoCheck',
  props: {
    checkList: {
      type: Array,
      default: () => []
    },
    infoPop: {
      type: Boolean,
      default: false
    },
    teamRecord: {
      type: Object,
      default: () => ({})
    },
    operationType: {
      type: String,
      default: 'improve', // 'improve' 完善认证信息, 'multiLanguage' 完善证书信息
      validator: value => ['improve', 'multiLanguage'].includes(value)
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.globalDataArray?.siteTemplateLanguage?.team_user_name || '成员姓名',
          dataIndex: 'memberName',
          key: 'memberName',
          scopedSlots: { customRender: 'memberName' }
        },
        // {
        //   title: '角色',
        //   dataIndex: 'role',
        //   key: 'role',
        //   scopedSlots: { customRender: 'role' },
        //   width: 80,
        //   align: 'center'
        // },
        // {
        //   title: '年级',
        //   dataIndex: 'grade',
        //   key: 'grade',
        //   width: 100,
        //   align: 'center'
        // },
        // {
        //   title: '组别',
        //   dataIndex: 'groupId',
        //   key: 'groupId',
        //   width: 100,
        //   align: 'center'
        // },
        {
          title: this.globalDataArray?.siteTemplateLanguage?.intro_phone || '联系电话',
          dataIndex: 'contact',
          key: 'contact',
          scopedSlots: { customRender: 'contact' }
        },
        {
          title: this.globalDataArray?.siteTemplateLanguage?.person_table_controls || '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ]
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  watch: {
    checkList: {
      immediate: true,
      handler(val) {
        this.tableData = val || []
      }
    }
  },
  created() {
    console.log('TeenagerInfoCheck checkList数据：', this.checkList)
  },
  methods: {
    handleSelect(record) {
      console.log('选择成员:', record)
      // 触发选择事件，传递选中的成员、团队记录和操作类型
      this.$emit('member-selected', {
        member: record,
        teamRecord: this.teamRecord,
        operationType: this.operationType
      })
      // 不关闭弹窗，保持打开状态，用户可以继续选择其他成员
      // this.cancelImpEdit()
    },

    cancelImpEdit() {
      this.tableData = []
      this.$emit('update:infoPop', false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/person.css';

.pagePopMask {
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.pagePop {
  z-index: 1000;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .w {
    position: relative;

         .tit {
       font-weight: bold;
       margin-bottom: 20px;
     }

    .selector-description {
      margin-bottom: 16px;
      color: #666;
      font-size: 14px;
    }

    .mb-3 {
      margin-bottom: 16px;
    }

    .member-name {
      font-weight: 600;
      color: #1890ff;
    }

    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
      cursor: pointer;

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 2px;
        height: 16px;
        background: #999;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      &:after {
        transform: translate(-50%, -50%) rotate(-45deg);
      }

      &:hover:before,
      &:hover:after {
        background: #333;
      }
    }

  }
}

/* 表格样式优化 */
::v-deep .ant-table-thead > tr > th {
  background-color: #fafafa;
  font-weight: 600;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background-color: #f6ffed;
}

::v-deep .ant-table-tbody > tr > td {
  padding: 12px 8px;
}
</style>
